export default __webpack_public_path__ + "static/media/hightlight3.319779fd.png";